import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
  };

  const logout = () => {
    api.post("/auth/logout").catch(() => {});
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  };

  const updateUser = (u, token) => {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    setUser(u);
  };

  const can = (p) => Boolean(user && user.permissions?.[p]);
  const isAdmin = Boolean(user && user.role === "admin");
  return <AuthCtx.Provider value={{ user, login, logout, can, isAdmin, updateUser }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);

export const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center text-sm text-slate-500" data-testid="auth-loading">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};
